import { Component } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { SettingsMenuService } from '@app/modules/settings/services/settings-menu.service';
import { AuthService } from '@app/services/auth.service';
import { FeatureService } from '@app/services/feature.service';
import { NotifyService } from '@app/services/notify.service';

@Component({
    templateUrl: './notifications-index.view.html',
    styleUrls: ['./notifications-index.style.scss'],
})
export class NotificationsIndexView {
    /**
     * Company setting, to be broken out into own model or
     * interface when entire settings system has been determined.
     */
    enableNotifications: boolean;
    showOfferLetterText = false;

    constructor(
        private authService: AuthService,
        private notify: NotifyService,
        private featureService: FeatureService,
        public settingsMenuService: SettingsMenuService
    ) {
        this.enableNotifications = !this.authService.company.suppressAllAlerts;
        this.setFeatureFlag();
    }

    onSave(event: boolean): void {
        this.enableNotifications = event;
        this.authService.company.suppressAllAlerts = !this.enableNotifications;

        this.authService.company.save().catch(() => {
            this.notify.error('settings.notifications.settingChangeErrorMessage');
        });
    }

    private async setFeatureFlag(): Promise<void> {
        this.showOfferLetterText = await this.featureService.has(FeatureFlag.offerLetters);
    }
}
